// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202607291909/js/" + chunkId + "." + {"44":"d5520b50","225":"d7f055aa","481":"6c67f5a4","486":"01d754ba","770":"eb67fce6"}[chunkId] + ".0.1335390512915542.chunk.js";
};